<template>
  <div class="mongo-card-container">
    <div
      v-for="(card, cardIndex) in mongoHardwareCardsData"
      :key="`${card.textLabel}-${cardIndex}`"
      class="mongo-card-element"
    >
      <InfoStats
        class="mongo-info-border"
        :textLabel="card.textLabel"
        :textValue="textValue[cardIndex]"
        :textValColor="cardValueColor(textValue, cardIndex)"
        fontSize="1rem"
        textValHeight="3rem"
        lineHeight="1.2rem"
      />
    </div>
    <div
      v-for="(card, index) in usageCardData"
      :key="`${card.textLabel}-${index}`"
      class="mongo-card-element"
    >
      <InfoStats
        class="mongo-info-border"
        :textLabel="card.textLabel"
        :textValue="storageCardData[index]"
        :textColor="card.textValColor"
        fontSize="1rem"
        textValHeight="3rem"
        lineHeight="1.2rem"
      />
    </div>
  </div>
</template>
<script>
import InfoStats from '@/rex-components/rex-info-stats.vue';
import {
  usageCardData,
  cardNamesMap,
  cardName,
  mongoHardwareCardsData,
} from '@/utils/templates/databaseTemplate/cards.config';
import {
  metricMongoDBTypes,
  cardNames,
} from '@/components/Database/database.types';
import {
  ACTIVE,
  INACTIVE,
  ONLINE,
  OFFLINE,
  BYTES_TO_MB_CONVERSION_VALUE,
} from '@/utils/templates/databaseTemplate/database.constants';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
export default {
  components: {
    InfoStats,
  },
  data() {
    return {
      usageCardData: usageCardData,
      avgCardData: { cpuUsage: 0, memoryUsage: 0 },
      storageCardData: [],
      cardNamesMap: cardNamesMap,
      cardName: cardName,
      loading: false,
      mongoHardwareCardsData: mongoHardwareCardsData,
    };
  },
  computed: {
    ...mapState('databaseState/detail', [
      'currentDatabaseInstance',
      'currentSubType',
    ]),
    ...mapState('databaseState/databaseCommonState', [
      'currentDatabaseType',
      'currentDatabaseService',
    ]),
    ...mapGetters('globalState/settings', ['getDurationTime', 'intervalTime']),
    textValue() {
      return mongoHardwareCardsData.map((cardData) => {
        if (this.currentDatabaseInstance?.key) {
          const attributes = this.currentDatabaseInstance?.attributes;
          const label = cardData.textLabel;
          if (label === cardNames.Availability) {
            return this.currentDatabaseInstance?.isActive ? ACTIVE : INACTIVE;
          } else {
            const cardValue = this.getAttributeValue(
              attributes,
              this.cardNamesMap[label],
            );
            return cardValue || this.$t('noData');
          }
        } else {
          return this.$t('noData');
        }
      });
    },
  },
  methods: {
    ...mapActions('databaseState/databaseCommonState', ['GET_AVG_DATA']),
    cardValueColor(arr, index) {
      if (arr[index] === ACTIVE || arr[index] === ONLINE) return 'good';
      else if (arr[index] === INACTIVE || arr[index] === OFFLINE) return 'poor';
      else return 'fair';
    },
    getAttributeValue(attributes, name) {
      const attribute = attributes.find((a) => a.name === name);
      return attribute ? attribute.value : this.$t('noData');
    },
    async getAvgData() {
      this.loading = true;
      try {
        this.avgCardData = await this.GET_AVG_DATA({
          serviceName: this.currentDatabaseService.key,
          duration: this.getDurationTime,
          endpointName: this.currentDatabaseInstance.key,
          cpuAvgMetricName: metricMongoDBTypes.METER_MONGO_CPU_USAGE,
          memoryAvgMetricName: metricMongoDBTypes.METER_MONGO_MEMORY_UASGE,
        });
        this.avgCardData.memoryUsage =
          (this.avgCardData.memoryUsage / BYTES_TO_MB_CONVERSION_VALUE).toFixed(
            2,
          ) || 0;
        this.storageCardData = Object.values(this.avgCardData);
        return this.storageCardData;
      } catch (error) {
        this.storageCardData = [];
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.getAvgData();
  },
  watch: {
    getDurationTime() {
      this.getAvgData();
    },
    currentDatabaseInstance() {
      this.getAvgData();
    },
  },
};
</script>
<style lang="scss" scoped>
.mongo-info-border {
  border-radius: 0.5rem;
}
.mongo-card-element {
  flex-basis: calc(50% - 0.5rem);
  border-radius: 0.5rem;
  margin-top: 0.3rem;
  margin-bottom: 0.2rem;
  height: 6rem;
}
.mongo-card-container {
  @include flex-row-wrap;
  justify-content: space-between;
}
</style>
